import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgClose = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M14.364 12.911 9.454 8l4.91-4.91-1.453-1.454L8 6.546l-4.911-4.91-1.453 1.453L6.546 8l-4.944 4.944 1.454 1.454L8 9.454l4.911 4.91z" /></svg>;
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;